/**
 * Labstep
 */

import {
  createSlice,
  type PayloadAction,
  type SliceCaseReducers,
} from '@reduxjs/toolkit';
import type { StateActiveMetabaseUrl } from './types';

const initialState: StateActiveMetabaseUrl = null;

export const activeMetabaseUrlSlice = createSlice<
  StateActiveMetabaseUrl,
  SliceCaseReducers<StateActiveMetabaseUrl>
>({
  name: 'activeMetabaseUrl',
  initialState,
  reducers: {
    setActiveMetabaseUrl: (
      _,
      action: PayloadAction<StateActiveMetabaseUrl>,
    ) => action.payload,
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => action.type === 'SUCCESS_CREATE_METABASE_URL',
      (_, action) => action.payload,
    );
  },
});

export const selectActiveMetabaseUrl = (state: any) =>
  state.activeMetabaseUrl;

export const { setActiveMetabaseUrl } =
  activeMetabaseUrlSlice.actions;

export default activeMetabaseUrlSlice.reducer;
